import { initialState as allSpot } from '../reducers/allSpotReducer'
import { initialState as citySpot } from '../reducers/citySpotReducer'
import { initialState as ui } from '../reducers/uiReducer'

const initialState = {
  allSpot,
  citySpot,
  ui
}

export default initialState
